import React from 'react';
import { translate } from 'react-i18next';

import EmployeeActions from 'actions/EmployeeActions';

class UnavailableSidebarItem extends React.Component {

  removeRequest() {
    EmployeeActions.cancelTimeOffRequest(this.props.requestId, this.props.id);
  }

  cancelRequestButton(state, source) {
    if (state == 'new' && source != 'adp' && source != 'e_days') {
      return (
        <button
          onClick={() => this.removeRequest()}
          className="calendar-input-button cancel-timeoff-button"
        >
          {' '}
          {this.props.t('UnavailableSidebarItem.cancel_request')}
          {' '}
        </button>
      );
    }
    return '';
  }

  timeOffNotes(notes) {
    if (!Utils.isNotDefined(notes) || notes !== '') {
      return (
        <span className="time-off-notes">
          <strong>{this.props.t('UnavailableSidebarItem.notes')}</strong>
          {notes}
        </span>
      );
    }
    return '';
  }

  dateRange(startDate, endDate) {
    if (startDate !== endDate) {
      return (
        <span>
          {`${startDate} - `}
          <br />
          {endDate}
        </span>
      );
    }
    return <span>{startDate}</span>;
  }

  render() {
    return (
      <li>
        <span className="pending-item">{this.props.displayedState}</span>
        <div style={{maxWidth: 190}}>{this.props.typeName}</div>
        {' '}
        <br />
        {this.dateRange(this.props.startDate, this.props.endDate)}
        {' '}
        <br />
        {this.props.hoursRange}
        {this.timeOffNotes(this.props.notes)}
        {this.cancelRequestButton(this.props.state, this.props.source)}
      </li>
    );
  }
}

export default translate()(UnavailableSidebarItem);
